import React, { useContext } from 'react'
import { GlobalContext } from '../context/GlobalState'

const Header = ({ style }) => {
  const context = useContext(GlobalContext)
  const { user } = context

  if(style === 'blurb') {
    return (
      <div className="listpage-head">
        <div className="secondary-header">
          <div>
            <i className={`fas fa-user${user.avatar}`}></i>
            <h5>{user.fname + " " + user.lname}</h5>
          </div>
          <i className="fas fa-bell"></i>
        </div>
        <h3>Share this list with your friends!</h3>
        <p>You can share a list with a friend by clicking on the users button below</p>
      </div>
    )
  } else if (style === 'mini') {
    return (
      <div className="listpage-head">
        <div className="secondary-header secondary-header-mini">
          <div>
            <i className={`fas fa-user${user.avatar}`}></i>
            <h5>{user.fname + " " + user.lname}</h5>
          </div>
          <i className="fas fa-bell"></i>
        </div>
      </div>
    )
  } else {
    return (
      <header>
        <i className={`fas fa-user${user.avatar}`}></i>
        <h2>{user.fname + " " + user.lname}</h2>
        <p>{user.bio}</p>
      </header>
    )
  }
}

export default Header
